<template>
  <div>
    <div @click="launchFilePicker()">
      <slot name="activator"></slot>
    </div>
    <input type="file"
       ref="file"
       :name="uploadFieldName"
       @change="onFileChange(
          $event.target.name, $event.target.files)"
       style="display:none">
  </div>
</template>

<script>
  export default {
    name: 'avatarInput',
    data: ()=> ({
      uploadFieldName: 'perfil.avatar',
      maxSize: 1024,
      modal: {
        title: '',
        body: '', 
        classe: 'modal-danger',
        icon: 'fa fa-times-circle',
        okButton: 'OK',
      }
    }),
    props: {
    // Use "value" to enable using v-model
      value: Object,
    },
    methods: {
      launchFilePicker(){
        this.$refs.file.click();
      },
      onFileChange(fieldName, file) {
        const { maxSize } = this
        let imageFile = file[0]

        if (file.length>0) {
          let size = imageFile.size / maxSize / maxSize
          if (!imageFile.type.match('image.*')) {
            // check whether the upload is an image
            this.modal.body = 'Por favor, selecione uma imagem';
            this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          } else if (size>1) {
            // check whether the size is greater than the size limit
            this.modal.body = 'Imagem muito grande! O arquivo deve ser menor que 1MB';
            this.$store.dispatch('modal/invokeStateModal', this.modal);
          } else {
            // Append file into FormData and turn file into image URL
            let formData = new FormData()
            let imageURL = URL.createObjectURL(imageFile)
            formData.append(fieldName, imageFile)
            // Emit the FormData and image URL to the parent component
            this.$emit('input', { formData, imageURL })
          }
        }
      }
    }
  }
</script>
